import React, { useEffect, useState } from 'react';
import { useField } from '@unform/core';

import { FilePicker } from './FilePicker';

interface IUploadMultipleProps {
  name: string;
  isDisabled?: boolean;
}

/**
 * Upload de múltiplas evidências, registrado no Unform como `File[]`.
 * Não faz upload no onChange — só guarda os File reais em memória; o envio
 * de fato acontece depois do POST principal (ver fluxo de submit da NC).
 */
export function UploadMultiple({ name, isDisabled }: IUploadMultipleProps) {
  const { fieldName, registerField, error } = useField(name);
  const [files, setFiles] = useState<File[]>([]);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => files,
      setValue: (_, value: File[]) => setFiles(value || []),
      clearValue: () => setFiles([]),
    });
  }, [fieldName, registerField, files]);

  return (
    <FilePicker
      id={`upload-${fieldName}`}
      files={files}
      onChange={setFiles}
      isDisabled={isDisabled}
      error={error}
    />
  );
}
